import Label from "ui-component/Label";
// 安全审核类型
export const LOG_TYPE = {
    0: { value: '0', text: '全部', color: '' },
    1: { value: '1', text: '充值', color: 'primary' },
    2: { value: '2', text: '消费', color: 'orange' },
    3: { value: '3', text: '管理', color: 'default' },
    4: { value: '4', text: '系统', color: 'secondary' },
    5: { value: '5', text: '联网搜索', color: 'secondary' },
    6: { value: '6', text: '消费-安全审核', color: 'orange' }
  };
  
  export function renderType(type) {
    const typeOption = LOG_TYPE[type];
    if (typeOption) {
      return (
        <Label variant="filled" color={typeOption.color}>
          {' '}
          {typeOption.text}{' '}
        </Label>
      );
    } else {
      return (
        <Label variant="filled" color="error">
          {' '}
          未知{' '}
        </Label>
      );
    }
  }